"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slate = require("slate");

var _slateReact = require("slate-react");

var _IconButton = require("../IconButton/IconButton");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

/* eslint-disable no-nested-ternary */
var TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];
var LIST_TYPES = ["numbered-list", "bulleted-list"];

var isBlockActive = function isBlockActive(editor, format, blockType) {
  if (blockType === void 0) {
    blockType = "type";
  }

  var selection = editor.selection;
  if (!selection) return false;

  var _Array$from = Array.from(_slate.Editor.nodes(editor, {
    at: _slate.Editor.unhangRange(editor, selection),
    match: function match(n) {
      return !_slate.Editor.isEditor(n) && _slate.Element.isElement(n) && n[blockType] === format;
    }
  })),
      match = _Array$from[0];

  return !!match;
};

var toggleBlock = function toggleBlock(editor, format) {
  var isActive = isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type");
  var isList = LIST_TYPES.includes(format);

  _slate.Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return !_slate.Editor.isEditor(n) && _slate.Element.isElement(n) && LIST_TYPES.includes(n.type) && !TEXT_ALIGN_TYPES.includes(format);
    },
    split: true
  });

  var newProperties;

  if (TEXT_ALIGN_TYPES.includes(format)) {
    newProperties = {
      align: isActive ? undefined : format
    };
  } else {
    newProperties = {
      type: isActive ? "paragraph" : isList ? "list-item" : format
    };
  }

  _slate.Transforms.setNodes(editor, newProperties);

  if (!isActive && isList) {
    var block = {
      type: format,
      children: []
    };

    _slate.Transforms.wrapNodes(editor, block);
  }
};

var BlockButton = function BlockButton(_ref) {
  var format = _ref.format,
      icon = _ref.icon;
  var editor = (0, _slateReact.useSlate)();
  return /*#__PURE__*/_react["default"].createElement(_IconButton.CircleButton, {
    size: 30,
    type: "button",
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleBlock(editor, format);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: icon,
    size: 20,
    activeColor: "dark.0",
    active: isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? "align" : "type")
  }));
};

var _default = BlockButton;
exports["default"] = _default;